import { DeliveryPriceAndDateResponse } from 'src/types';
import { deliveryPriceAndDateOptionBuilder } from './deliveryPriceAndDateOption';

const defaults: Readonly<DeliveryPriceAndDateResponse> = {
  deliveryOptions: [deliveryPriceAndDateOptionBuilder()],
  exceptional: false,
  groupingCode: 'primary_domestic',
  zoneCode: 'MAINLAND_UK',
};

export const deliveryPriceAndDateBuilder = (
  overrides?: Partial<DeliveryPriceAndDateResponse>,
): Readonly<DeliveryPriceAndDateResponse> => ({ ...defaults, ...overrides });
